import { render, staticRenderFns } from "./EditProjectForm.vue?vue&type=template&id=5ef7b310&"
import script from "./EditProjectForm.vue?vue&type=script&lang=ts&"
export * from "./EditProjectForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditProjectForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports